var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
function isArrayValue(value, multiple) {
  return !!multiple;
}
__name(isArrayValue, "isArrayValue");
export {
  isArrayValue
};
//# sourceMappingURL=utils.js.map
